import NextLink from "next/link";
import {
  Box,
  Text,
  IconFa,
  Link,
  type SpaceType,
} from "@cruk/cruk-react-components";
import { faPeopleGroup } from "@fortawesome/free-solid-svg-icons";

import { useSwrGet } from "@fwa/src/hooks/useSwrGet";
import { fwsUrlPageParentMemberships } from "@fwa/src/services/fundraisingPageService";

import sharedStyles from "@fwa/src/components/styles.module.css";

import type { FwsResponseData, PageType, TeamMemberType } from "@fwa/src/types";

export function MemberOf({
  page,
  hasPadding = false,
  marginTop,
  textOnPrimary = false,
  fallbackData,
}: {
  page: PageType;
  hasPadding?: boolean;
  marginTop?: SpaceType;
  textOnPrimary?: boolean;
  fallbackData?: FwsResponseData<TeamMemberType>;
}) {
  const url = page
    ? `${fwsUrlPageParentMemberships({
        pageId: page.uniqueId,
        currentPage: 1,
        itemsPerPage: 3,
      })}`
    : null;
  const { data } = useSwrGet<FwsResponseData<TeamMemberType>>(url, {
    fallbackData,
    revalidateOnMount: true,
  });
  const memberships = data?.results || [];

  if (!memberships?.length) return null;

  const textColor = textOnPrimary ? "text-on-primary" : "text-dark";

  return (
    <Box
      padding={hasPadding ? "s" : "none"}
      paddingBottom="none"
      marginBottom="none"
      marginTop={marginTop}
      data-component="member-of"
    >
      <div className={sharedStyles["row"]}>
        <Box paddingRight="xs" marginBottom="none">
          <IconFa faIcon={faPeopleGroup} color={textColor} />
        </Box>
        <Text as="span" textColor={textColor} marginBottom="none">
          {` A member of `}
        </Text>
        {memberships?.map((membership: TeamMemberType, index: number) => {
          const team = membership.parentPage;
          const key = `member${membership.uniqueId || ""}`;
          return (
            <span key={key} className="color-props" data-color={textColor}>
              {`${index > 0 ? " and " : ""}`}
              <NextLink
                href={team.url.replace(/https?:\/\/[^/]*/, "")}
                data-cta-type="link-team"
              >
                <Link as="span" textColor={textColor} marginHorizontal="xxs">
                  {team.title}
                </Link>
              </NextLink>
            </span>
          );
        })}
      </div>
    </Box>
  );
}

export default MemberOf;
